// src/pages/AdminDataExplorer.jsx
import React, { useState } from "react";

export default function AdminDataExplorer() {
  const [collection, setCollection] = useState("poolitems");
  const [query, setQuery] = useState("");
  const [results, setResults] = useState([]);
  const [loading, setLoading] = useState(false);

  const collections = [
    { value: "poolitems", label: "Pool Items" },
    { value: "sklady", label: "Sklady" },
    { value: "pohyby", label: "Pohyby" },
    { value: "karty", label: "Karty" },
  ];

  const handleSearch = async () => {
    if (!query.trim()) return;

    setLoading(true);
    try {
      const res = await fetch("/api/search", {
        method: "POST",
        credentials: "include",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ collection, query }),
      });

      if (!res.ok) throw new Error("Chyba při vyhledávání");

      const json = await res.json();
      setResults(json);
    } catch (err) {
      console.error(err);
      setResults([]);
    }
    setLoading(false);
  };

  return (
    <div style={{ padding: "20px" }}>
      <h1 style={{ fontSize: "22px", fontWeight: "600", marginBottom: "15px" }}>
        🔍 Admin Data Explorer
      </h1>

      <div style={{ display: "flex", gap: "10px", marginBottom: "15px" }}>
        <select
          value={collection}
          onChange={(e) => setCollection(e.target.value)}
          style={{ padding: "6px 10px" }}
        >
          {collections.map((c) => (
            <option key={c.value} value={c.value}>
              {c.label}
            </option>
          ))}
        </select>

        <input
          type="text"
          placeholder="Hledat podle názvu, PDK nebo šarže..."
          value={query}
          onChange={(e) => setQuery(e.target.value)}
          style={{ padding: "6px 10px", width: "300px" }}
        />

        <button
          onClick={handleSearch}
          style={{
            background: "#007bff",
            color: "white",
            padding: "6px 12px",
            border: "none",
            borderRadius: "6px",
            cursor: "pointer",
          }}
        >
          {loading ? "Hledám..." : "Vyhledat"}
        </button>
      </div>

      {results.length > 0 && (
        <div style={{ overflowX: "auto" }}>
          <table border="1" cellPadding="5" width="100%">
            <thead style={{ background: "#f5f5f5" }}>
              <tr>
                {Object.keys(results[0]).map((k) => (
                  <th key={k}>{k}</th>
                ))}
              </tr>
            </thead>
            <tbody>
              {results.map((r, i) => (
                <tr key={i}>
                  {Object.values(r).map((v, j) => (
                    <td key={j}>
                      {typeof v === "object" && v !== null
                        ? JSON.stringify(v)
                        : String(v)}
                    </td>
                  ))}
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}

      {!loading && results.length === 0 && query && (
        <div style={{ marginTop: "20px", color: "#777" }}>
          Žádné výsledky
        </div>
      )}
    </div>
  );
}
